// extracted by mini-css-extract-plugin
export default {"chatwrp":"chatwrp__B4tYj","fullscreen":"fullscreen__bUw7S","iframeWrp":"iframeWrp__ycl+3"};